import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class PedidoService {

  	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
	}

  	getAll(queryString: String = "") {
		let url = this.host_api + '/pedidos' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getDetalles(queryString: String = "") {
		let url = this.host_api + '/pedidos/detalles' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getPedidos(queryString: String = "") {
		let url = this.host_api + '/pedidos/getPedidos' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getPedidosPorEntregar(queryString: String = "") {
		let url = this.host_api + '/pedidos/porentregar' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer " + this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getById(id, qs = "") {
		let url = this.host_api + '/pedidos/' + id + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	save(orden) {
		let url = this.host_api + '/pedidos';
		let params = orden;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	update(orden) {
		let url = this.host_api + '/pedidos/' + orden.id;
		let params = JSON.stringify(orden);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	// delete(id) {
	// 	var url = this.host_api + '/pedidos/' + id + '/del';
	// 	let params = {usuario_id: this.ss.getData('usuario_id')};
	// 	let headers = new Headers({ 'Content-type': 'application/json' });
	// 	headers.append('Authorization', "Bearer "+ this._token);
	// 	headers.append('dbname', this.dbname);
	// 	let options = new RequestOptions({ headers: headers });

	// 	return this.http.put(url, params, options).map((res:Response) => {
	// 		return this.config.onSuccessResponse(res);
	// 	}).catch((error: any) => {
	// 		return this.config.onErrorResponse(error);
	// 	});		
	// }

	changeStatus(pedidos) {
		var url = this.host_api + '/pedidos/' + pedidos + '/del';
		// let params = {usuario_id: this.ss.getData('usuario_id'), JSON.stringify(pedidos)};
		let params = JSON.stringify(pedidos)
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	entregarPedido(pedido){
		var url = this.host_api + '/pedidos/entregar/' + pedido.id;
		// let params = {usuario_id: this.ss.getData('usuario_id'), JSON.stringify(pedidos)};
		let params = JSON.stringify(pedido);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	facturarPedidos(ventas) {
		let url = this.host_api + '/pedidos/facturar';
		let params = ventas;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	calcularTotales(pedido, tipo_comprobante_id: String, pedido_detalle, IVA: number, total_pago: number) {
        pedido.subtotal_iva12 = 0;
        pedido.subtotal_iva0 = 0;
        pedido.subt_desct_iva12 = 0;
        pedido.subt_desct_iva0 = 0;
        pedido.iva = 0;
        pedido.total = 0;

        pedido_detalle.forEach(obj => {
			if( (tipo_comprobante_id == "1" && obj.graba_iva) || tipo_comprobante_id == "4" && obj.graba_iva ){
                pedido.subtotal_iva12 += parseFloat(obj.subtotal.toString());
            }else{
                pedido.subtotal_iva0 += parseFloat(obj.subtotal.toString());
            }
        });

        let desc_porcent = (pedido.desct_porcent / 100);
        desc_porcent = Math.round(desc_porcent * 100) / 100;
        pedido.desct_valor = (pedido.subtotal_iva0 + pedido.subtotal_iva12) * desc_porcent;
        pedido.subt_desct_iva0 = pedido.subtotal_iva0 - (desc_porcent * pedido.subtotal_iva0);
        pedido.subt_desct_iva12 = pedido.subtotal_iva12 - (desc_porcent * pedido.subtotal_iva12);

        if( tipo_comprobante_id == "1" || tipo_comprobante_id == "4" ){
            pedido.iva = Math.round((pedido.subt_desct_iva12 * IVA) * 100) / 100;
        }else{
            pedido.iva = Math.round(pedido.subt_desct_iva12 * 100) / 100;
        }
        
        pedido.total = pedido.subt_desct_iva12 + pedido.subt_desct_iva0 + pedido.iva;

        pedido.cambio = (total_pago > pedido.total?(total_pago - pedido.total):0);
        pedido.cambio = Math.round(pedido.cambio * 100) / 100;

        return pedido;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/pedido.service.ts